import { CONTENT } from "../shared/content";

function isHorizonStage(levelIndex: number): boolean {
  return CONTENT.levels[levelIndex]?.id === "level04";
}

export const LEVEL04_BGM_KEY = "level04-horizon-home";
export const LEVEL04_BGM_URL = "/assets/audio/level04-horizon-home.mp3";
export const LEVEL04_BOSS_BGM_KEY = "level04-zuckerberg-metaverse";
export const LEVEL04_BOSS_BGM_URL = "/assets/audio/level04-zuckerberg-metaverse.mp3";
export const LEVEL04_BGM_VOLUME = 0.42;
export const LEVEL04_BGM_FADE_MS = 480;

export function shouldLoopLevel04Theme(input: {
  levelIndex: number;
  activeWaveId: string | null;
  practiceBossStart: boolean;
  silencedForBoss: boolean;
}): boolean {
  if (!isHorizonStage(input.levelIndex)) return false;
  if (input.practiceBossStart) return false;
  if (input.silencedForBoss) return false;
  return input.activeWaveId !== "boss";
}

export function shouldLoopLevel04BossTheme(input: {
  levelIndex: number;
  activeWaveId: string | null;
  practiceBossStart: boolean;
  silencedForBoss: boolean;
}): boolean {
  if (!isHorizonStage(input.levelIndex)) return false;
  if (input.practiceBossStart) return true;
  if (input.silencedForBoss) return true;
  return input.activeWaveId === "boss";
}
